// @flow

import React from 'react';

import OneServiceSplitLoginPageContainer from 'app/login/components/OneServiceSplitLoginPageContainer';
import TeamMemberSplitLoginPageContainer from 'app/login/components/TeamMemberSplitLoginPageContainer';
import TwoServiceSplitLoginPageContainer from 'app/login/components/TwoServiceSplitLoginPageContainer';
import ZtSplitLoginPageContainer from 'app/login/components/ZtSplitLoginPageContainer';
import SplitLoginPage, {
  type SplitLoginPageProps,
} from 'app/login/components/SplitLoginPage';

const SplitLoginPageWrapper = (props: SplitLoginPageProps) => {
  if (props.isZt) {
    return <ZtSplitLoginPageContainer {...props} />;
  }

  if (props.isTeamMemberInvitation) {
    return <TeamMemberSplitLoginPageContainer {...props} />;
  }

  if (props.isOneService) {
    return <OneServiceSplitLoginPageContainer {...props} />;
  }

  if (props.isTwoService) {
    return <TwoServiceSplitLoginPageContainer {...props} />;
  }

  return <SplitLoginPage {...props} />;
};

export default SplitLoginPageWrapper;
